export const ELocationCategory = {
  "0": "UNKNOWN",
  "1": "FLIGHT",
  "2": "HOTEL",
  "3": "TRANSFER",
  "4": "RENT_A_CAR",
  "5": "TRANSFER_REISETECH",
  "-1": "ALL"
};

export const ELocationStatus = {
  "0": "UNKNOWN",
  "1": "ACTIVE",
  "2": "PASSIVE",
  "-1": "ALL"
};

export const ELocationType = {
  "0": "UNKNOWN",
  "1": "ROOT",
  "2": "COUNTRY",
  "3": "STATE",
  "4": "REGION",
  "5": "CITY",
  "6": "DISTRICT",
  "7": "UNIT",
  "8": "SUB_UNIT",
  "9": "AIRPORT",
  "-1": "ALL"
};

export const EDestinationType = {
  "0": "UNKNOWN",
  "1": "LOCATION",
  "2": "HOTEL",
  "-1": "ALL"
};

export const EDestinationSyncStatus = {
  "0": "UNKNOWN",
  "1": "SYNCED",
  "2": "NOT_SYNCED",
  "-1": "ALL"
};

export const ECountryPatternType = {
  "0": "UNKNOWN",
  "1": "COUNTRY_STATE_CITY_DISTRICT_UNIT_SUBUNIT",
  "2": "COUNTRY_REGION_CITY_DISTRICT_UNIT_SUBUNIT",
  "3": "COUNTRY_STATE_REGION_CITY_DISTRICT_UNIT_SUBUNIT",
  "-1": "ALL"
};